module.exports = __webpack_public_path__ + "static/media/planilha.055a92c6.xlsx";